/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UploadBulkTimeseriesRainFile
 */
export interface UploadBulkTimeseriesRainFile {
  /**
   *
   */
  readonly putUrl?: string;
  /**
   *
   */
  filename: string;
  /**
   *
   */
  readonly status?: string;
  /**
   *
   */
  offset: number;
  /**
   *
   */
  epsgCode?: number;
}

/**
 * Check if a given object implements the UploadBulkTimeseriesRainFile interface.
 */
export function instanceOfUploadBulkTimeseriesRainFile(
  value: object
): value is UploadBulkTimeseriesRainFile {
  if (!("filename" in value) || value["filename"] === undefined) return false;
  if (!("offset" in value) || value["offset"] === undefined) return false;
  return true;
}

export function UploadBulkTimeseriesRainFileFromJSON(json: any): UploadBulkTimeseriesRainFile {
  return UploadBulkTimeseriesRainFileFromJSONTyped(json, false);
}

export function UploadBulkTimeseriesRainFileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UploadBulkTimeseriesRainFile {
  if (json == null) {
    return json;
  }
  return {
    putUrl: json["put_url"] == null ? undefined : json["put_url"],
    filename: json["filename"],
    status: json["status"] == null ? undefined : json["status"],
    offset: json["offset"],
    epsgCode: json["epsg_code"] == null ? undefined : json["epsg_code"],
  };
}

export function UploadBulkTimeseriesRainFileToJSON(json: any): UploadBulkTimeseriesRainFile {
  return UploadBulkTimeseriesRainFileToJSONTyped(json, false);
}

export function UploadBulkTimeseriesRainFileToJSONTyped(
  value?: Omit<UploadBulkTimeseriesRainFile, "putUrl" | "status"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    filename: value["filename"],
    offset: value["offset"],
    epsg_code: value["epsgCode"],
  };
}
